import Analytics from "./Analytics";

export default class VocalReader {
    static loadVoices(callback) {
        const voices = window.speechSynthesis.getVoices();
        if (voices.length) {
            callback(voices);
        } else {
            window.speechSynthesis.onvoiceschanged = () => {
                const updatedVoices = window.speechSynthesis.getVoices();
                callback(updatedVoices);
            };
        }
    }

    static initializeEvents() {
        const readers = document.querySelectorAll('.vocal-reader');

        readers.forEach(reader => {
            if (reader.querySelector('.vocal-reader-btn')) return;

            const button = document.createElement('button');
            button.className = 'vocal-reader-btn ri-volume-up-line text-blue-113 cursor-pointer p-0 ml-1w';
            button.type = 'button';
            button.title = 'Lire ce texte';
            button.setAttribute('data-analytics-tag', `Lecteur vocal||Quizz||${window.location.pathname}`);

            reader.appendChild(button);
            Analytics.attachTo(button);

            const voiceLang = reader.dataset.voice || 'fr-FR';

            const getTexte = () => reader.textContent.trim();

            let currentUtterance = null;

            const setIcon = (state) => {
                button.classList.remove('ri-volume-up-line', 'ri-stop-circle-line', 'ri-pause-circle-line');
                switch (state) {
                    case 'idle':
                        button.classList.add('ri-volume-up-line');
                        break;
                    case 'playing':
                        button.classList.add('ri-pause-circle-line');
                        break;
                    case 'paused':
                        button.classList.add('ri-stop-circle-line');
                        break;
                }
            };

            button.addEventListener('click', () => {
                if (window.speechSynthesis.paused) {
                    window.speechSynthesis.resume();
                    setIcon('playing');
                    return;
                }

                if (window.speechSynthesis.speaking) {
                    window.speechSynthesis.pause();
                    setIcon('paused');
                    return;
                }

                const texte = getTexte();
                if (!texte || !('speechSynthesis' in window)) {
                    button.remove();
                    return;
                }

                VocalReader.loadVoices(voices => {
                    const utterance = new SpeechSynthesisUtterance(texte);
                    currentUtterance = utterance;

                    const matchingVoice = voices.find(v => v.lang.startsWith(voiceLang));
                    if (matchingVoice) {
                        utterance.voice = matchingVoice;
                    }

                    utterance.onend = () => {
                        setIcon('idle');
                        currentUtterance = null;
                    };

                    utterance.onerror = () => {
                        setIcon('idle');
                        currentUtterance = null;
                    };

                    setIcon('playing');
                    window.speechSynthesis.speak(utterance);
                });
            });
        });
    }
}
